module.exports = __webpack_public_path__ + "img/head.0754c4a5.jpg";